export default {
  setUltimaSincronizacionProductos(state, i) {
    state.ultimaSincronizacionProductos = i;
  }
}